module.exports = __webpack_public_path__ + "img/hryvnia-sign.e47b01ab.svg";